import { type ObjectMode } from '@databases/types';
import {
  type ContentProperty,
  type ContentPropertyKey
} from '@databases/types/confluence';

import { fetchConfluenceData, rejectOnError } from './fetch.ts';

export async function getContentProperty<Key extends ContentPropertyKey>(
  contentId: string,
  key: Key
): Promise<ContentProperty<Key> | undefined> {
  const res = await fetchConfluenceData(
    `/rest/api/content/${encodeURIComponent(contentId)}/property/${encodeURIComponent(
      key
    )}`
  );
  if (res.status === 404) {
    return undefined;
  }
  await rejectOnError(res);
  return await res.json();
}

export async function updateContentProperty<Key extends ContentPropertyKey>(
  contentId: string,
  property: ContentProperty<Key, ObjectMode.UPDATE>
): Promise<ContentProperty<Key>> {
  const res = await fetchConfluenceData(
    `/rest/api/content/${encodeURIComponent(contentId)}/property/${encodeURIComponent(
      property.key
    )}`,
    {
      method: 'PUT',
      headers: {
        'Content-type': 'application/json'
      },
      body: JSON.stringify(property)
    }
  ).then(rejectOnError);
  return await res.json();
}
